'use client';

import { useTranslations } from 'next-intl';
import {
  buildExternalAssetPostureItems,
  sumPostureCounts,
  type ExternalAssetKind,
} from '../../dashboard/posture-items';
import { PostureCard } from '../../dashboard/PostureCard';
import { useOpenListFromHome } from '../../dashboard/useOpenListFromHome';

type ExternalAssetsPostureCardProps = {
  surfaceId: string;
  counts: Record<ExternalAssetKind, number> | undefined;
  isLoading: boolean;
};

const NO_ASSETS: Record<ExternalAssetKind, number> = {
  hosts: 0,
  domains: 0,
  services: 0,
  gateways: 0,
  netblocks: 0,
  software: 0,
};

export function ExternalAssetsPostureCard({
  surfaceId,
  counts,
  isLoading,
}: ExternalAssetsPostureCardProps) {
  const t = useTranslations('home.posture');
  const { openList, openListContextMenu } = useOpenListFromHome({
    applicationId: surfaceId,
  });
  const items = buildExternalAssetPostureItems({
    counts: counts ?? NO_ASSETS,
  }).map((item) => ({ ...item, label: t(`assetKinds.${item.key}`) }));

  return (
    <PostureCard<ExternalAssetKind>
      title={t('assetsByType')}
      total={sumPostureCounts(items)}
      items={items}
      isLoading={isLoading}
      emptyLabel={t('noAssets')}
      onSelect={() => openList({ list: 'assets' })}
      onTitleClick={() => openList({ list: 'assets' })}
      onTitleContextMenu={(event) =>
        openListContextMenu(event, { list: 'assets' })
      }
    />
  );
}
